const gap = 50

export default gap
